import {
    APPLY_TRANSITION,
    ImplementationType,
    SupportedType,
    TransitionSpeed,
    TransitionType,
    SpeedDurationMap,
} from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import {
    IAnimationSetting,
    ITransition, ITransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { Proxify } from '@src/slide/infrastructure/module/independent/proxy/data-proxify-class-decorator';

export abstract class BaseTransitionModel<T extends ITransition = ITransition> implements ITransitionModel {
    public property: T;
    public type: TransitionType;
    public duration: number;
    public speed: TransitionSpeed;
    public advanceOnClick?: boolean;
    public advanceAfterTime?: number;


    public constructor() {
        // 自动切页逻辑有问题，暂时先不启用。待修复后启用
        // this.advanceOnClick = transition.advClick;
        // this.advanceAfterTime = transition.advTm && parseInt(transition.advTm);
    }

    public initProperty() {
        this.property = new BaseTransitionProperty(this) as unknown as T;
    }

    /**
     * 是否支持播放该类型动画
     */
    public get isSupported(): boolean {
        return APPLY_TRANSITION && SupportedType.filter(type => type === this.type).length > 0;
    }

    /**
     * 是否可以通过点击切页
     */
    public get forbidClickToAdvance(): boolean {
        // 为false时才禁用
        return this.advanceOnClick === false;
    }

    /**
     * 是否自动切页
     * 设置自动切页时需要主动播放主队列动画
     */
    public get autoAdvance(): boolean {
        return !!this.advanceAfterTime;
    }

    public get animationDuration(): number {
        return (this.property?.duration ?? 0) / 1000;
    }

    public getImplementationType(): ImplementationType {
        return ImplementationType.FLAT;
    }

    /**
     * 获取 transition 执行时每个动画的设置项
     */
    public abstract getAnimationSetting(isSwitchForward?: boolean): IAnimationSetting[];
}

@Proxify
export class BaseTransitionProperty implements ITransition {
    constructor(private data: ITransition) {}

    public get duration() {
        return this.data.duration ?? SpeedDurationMap[this.speed];
    }

    public get speed() {
        return this.data.speed ?? TransitionSpeed.FAST;
    }

    // 自动切页逻辑有问题，暂时先不启用。待修复后启用
    public get advanceOnClick() {
        return undefined;
    }

    // 自动切页逻辑有问题，暂时先不启用。待修复后启用
    public get advanceAfterTime() {
        return undefined;
    }
}
